export enum EProperty {
  listSave = "list.save",
  lastStation = "lastStation"
}
